import React, { Component } from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  CustomInput,
  Label,
  Row } from 'reactstrap';
import NumberFormat from 'react-number-format';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import { toast } from 'react-toastify';
import { FilePond } from 'react-filepond';

class ApplicationDetailApproved extends Component {
  state = {
    status: 'approved',
    isPaneOpen: false,
    financedAmount: 4322.34,
    refundAmount: null,
    payoutAmount: 0,
    newFinancedAmount: 0,
    chargebackAmount: 0,
    disabled: true,
    termsAgree: false,
  }

  componentDidMount() {
    Modal.setAppElement(this.el);
  }

  handleRefundChange = () => {
    const { financedAmount } = this.state;
    const refundInput = document.getElementById('refundAmount');
    var newRefundAmount = (refundInput.value).replace(/[^0-9.]+/g, "");
    const newPayoutAmount = (financedAmount - newRefundAmount) * 0.025;
    const newFinancedAmount = financedAmount - newRefundAmount;
    const newChargebackAmount = newRefundAmount;

    this.setState({
      refundAmount: newRefundAmount,
      payoutAmount: newPayoutAmount,
      newFinancedAmount: newFinancedAmount,
      chargebackAmount: newChargebackAmount
    });
  }

  handleTermsCheck = () => {
    this.setState({termsAgree: !this.state.termsAgree});
  }

  handleSignature = (evt) => {
    if (evt.target.value.length && this.state.termsAgree) {
      this.setState({
        disabled: false
      });
    } else {
      this.setState({
        disabled: true
      });
    }
  }

  handleSubmit = () => {
    const RequestRefundBtn = document.getElementById('RequestRefundBtn');
    this.setState({
      status: 'refund-pending',
      isPaneOpen: false
    });
    RequestRefundBtn.style.display = 'none';
    toast.info(
      <div>
        <h5>We successfully received your refund request</h5>
        <small>Requests are typically processed within 24 hours</small>
      </div>
    );
  }

  formatCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })

  RequestRefundTray = () => {
    const { financedAmount, refundAmount, payoutAmount, newFinancedAmount, chargebackAmount } = this.state;
    const refundInput = document.getElementById('refundAmount');

    return (
      <SlidingPane
        isOpen={ this.state.isPaneOpen }
        closeIcon={<img src='/icons/arrow-left-grey.svg' alt='close' />}
        title='Request Refund'
        width='460px'
        onRequestClose={ () => {this.setState({ isPaneOpen: false });} }>

        <Form className="d-flex flex-column">
          <FormGroup>
            <Label for="refundAmount">Refund Amount</Label>
            <Input
              type="tel"
              name="refund-amount"
              id="refundAmount"
              tag={NumberFormat}
              thousandSeparator={true}
              prefix={'$'}
              onChange={this.handleRefundChange}
              value={refundAmount}
            />
            <CustomInput
              type="checkbox"
              id="fullRefund"
              className="mt-1"
              label="Issue full refund"
            />
          </FormGroup>
          <FormGroup>
            <Label for="refundReason">Reason for Refund</Label>
            <Input type="text" name="refund-reason" id="refundReason" required />
          </FormGroup>
          <Container className="refund-calculator">
            <Row>
              <Col xs={4}>
                <h6>New Payout<br /> Amount</h6>
                <div className="calcValue">
                  {payoutAmount > 0 && refundInput.value ? (
                    this.formatCurrency.format(payoutAmount)
                  ) : (
                    <div>$<span>–––</span></div>
                  )}
                </div>
              </Col>
              <Col xs={4}>
                <h6>New Financed<br /> Amount</h6>
                <div className="calcValue">
                  {payoutAmount > 0 && newFinancedAmount !== financedAmount ? (
                    this.formatCurrency.format(newFinancedAmount)
                  ) : (
                    <div>$<span>–––</span></div>
                  )}
                </div>
              </Col>
              <Col xs={4}>
                <h6>Chargeback<br /> Amount</h6>
                <div className="calcValue calcChargeback">
                  {chargebackAmount > 0 && chargebackAmount <= financedAmount ? (
                    this.formatCurrency.format(chargebackAmount)
                  ) : (
                    <div>($<span>–––</span>)</div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
          <FormGroup>
            <CustomInput
              type="checkbox"
              id="agree"
              label="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud."
              onChange={this.handleTermsCheck}
            />
          </FormGroup>
          <FormGroup>
            <Label for="signature">Signature – Type Full Name</Label>
            <Input
              type="text"
              name="signature"
              id="signature"
              onChange={this.handleSignature}
            />
          </FormGroup>
          <Button
            color="primary"
            id="SubmitRefundRequest"
            className="w-100 mt-auto"
            disabled={this.state.disabled}
            onClick={this.handleSubmit}>
            Request Refund
          </Button>
        </Form>

      </SlidingPane>
    )
  }

  render() {
    return (
      <div className="page-dashboard" ref={ref => this.el = ref}>

        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={6} lg={8} xl={10} className="text-center text-md-left">
              <h3 className="d-lg-flex mb-3 mb-md-0">Application ID: 2561435 &nbsp;&nbsp;
                { this.state.status === 'approved' && <Badge color="success" className="mt-1 mt-lg-0">Approved</Badge> }
                { this.state.status === 'refund-pending' && <Badge color="secondary" className="mt-1 mt-lg-0">Refund Pending</Badge> }
              </h3>
            </Col>
            <Col md={6} lg={4} xl={2}>
              <Container className="p-0 d-md-none mobile-buttons" fluid>
                <Row noGutters>
                  <Col md="auto" className="pl-3 pr-3">
                    <Button
                      onClick={() => this.setState({ isPaneOpen: true })}
                      id="RequestRefundBtn"
                      className="w-100"
                      color="secondary">
                      Request Refund
                    </Button>
                  </Col>
                </Row>
              </Container>
              <Container className="p-0 d-none d-md-block" fluid>
                <Row className="flex-md-row justify-content-end" noGutters>
                  <Col className="text-right">
                    <Button
                      onClick={() => this.setState({ isPaneOpen: true })}
                      id="RequestRefundBtn"
                      className="w-100"
                      color="secondary"
                      size="sm">
                      Request Refund
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

            <Card>
              <CardHeader>Personal Information</CardHeader>
              <CardBody>
                <Form>
                  <FormGroup>
                    <Label for="firstName">First Name</Label>
                    <Input type="text" name="first-name" id="firstName" defaultValue="Kyle" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="middleName">Middle Name</Label>
                    <Input type="text" name="middle-name" id="middleName" defaultValue="Branden" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="lastName">Last Name</Label>
                    <Input type="text" name="last-name" id="lastName" defaultValue="McConnell" />
                  </FormGroup>
                  <Row form>
                    <Col xs="12" xl="6">
                      <FormGroup>
                        <Label for="SSN">Last 4 of SSN</Label>
                        <Input type="text" name="ssn" id="SSN" defaultValue="4321" />
                      </FormGroup>
                    </Col>
                    <Col xs="12" xl="6">
                      <FormGroup>
                        <Label for="DOB">Date of Birth</Label>
                        <Input type="text" name="dob" id="DOB" defaultValue="09/08/1943" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup className="dropdown-toggle">
                    <Label for="maritalStatus">Marital Status</Label>
                    <Input type="select" name="marital-status" id="maritalStatus">
                      <option value="">Select...</option>
                      <option value="Single">Single</option>
                      <option value="Married">Married</option>
                      <option value="Divorced">Divorced</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="Email">Email Address</Label>
                    <Input type="text" name="email" id="Email" defaultValue="kylefoundry@gmail.com" />
                  </FormGroup>
                  <Row form>
                    <Col xs="12" xl="6">
                      <FormGroup>
                        <Label for="homePhone">Home Phone</Label>
                        <Input type="text" name="home-phone" id="homePhone" defaultValue="(123) 456-7890" />
                      </FormGroup>
                    </Col>
                    <Col xs="12" xl="6">
                      <FormGroup>
                        <Label for="cellPhone">Cell Phone</Label>
                        <Input type="text" name="cell-phone" id="cellPhone" defaultValue="(321) 456-7890" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button className="w-100 mt-1" disabled>Save</Button>
                </Form>
              </CardBody>
            </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card>
                <CardHeader>Borrower Address</CardHeader>
                <CardBody>
                  <p>Address of the primary borrower</p>
                  <Form>
                    <FormGroup>
                      <Label for="Address">Address</Label>
                      <Input type="text" name="address" id="Address" defaultValue="1020 W Lawrence Ave" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="Address2">Address 2</Label>
                      <Input type="text" name="address2" id="Address2" placeholder="Apartment, studio, or floor" defaultValue="Apt #508" />
                    </FormGroup>
                    <FormGroup>
                      <Label for="City">City</Label>
                      <Input type="text" name="city" id="City" defaultValue="Chicago" />
                    </FormGroup>
                    <Row form>
                      <Col md={8}>
                        <FormGroup>
                          <Label for="State">State</Label>
                          <Input type="text" name="state" id="State" defaultValue="Illinois" />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="Zip">Zip</Label>
                          <Input type="text" name="zip" id="Zip" defaultValue="60640" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button className="w-100 mt-1" disabled>Save</Button>
                  </Form>
                </CardBody>
              </Card>

            </Col>
            <Col md={6} lg={4}>

              <Card className="border-primary">
                <CardHeader>Action Center</CardHeader>
                <CardBody className="text-center">
                  <Row>
                    <Col>
                      <h5 className="mb-2">ID Upload - Front</h5>
                      <FilePond />
                    </Col>
                    <Col>
                      <h5 className="mb-2">ID Upload - Back</h5>
                      <FilePond />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

            </Col>
          </Row>

        </Container>

        <this.RequestRefundTray />

      </div>
    );
  }
}

export default ApplicationDetailApproved;
